export function __version() {
	return (
		<div className='__version'>
			<div>Phiên bản 1.0.3</div>
		</div>
	);
}
